import React, { useContext } from 'react'
import { getLabel } from '../../../data/labels';
import { BetslipContext } from '../../../data/betslip/BetslipConf';
import { getConfiguration, oddToString } from '../../../data/utils';
import AmountBetslipForm from '../AmountBetslipForm';

const EventCouponWh = (props) => {
	const betslipContext = useContext(BetslipContext);
	const betslipData = betslipContext.getBetslipData();
	const conf = getConfiguration();
	const selection = props.selection;
	const isSingle = props.container === 'singlebets';
	const isMultiple = props.container === 'multibets';
	const bankerEnabled = conf.sybe != null ? conf.sybe : true;
	const isSystem = props.container === 'systembets';;
	const isLive = selection.isLive;
	let bets = selection.bets;
	// restoring the bets array: if it is not a systembet, then I will draw just the first bet
	if (!isSystem && !betslipContext.isBetBuilder()) {
		let aux = [];
		if (bets.length > 0) {
			aux.push(bets[0]);
		}
		bets = aux;
	}
	function getBetKey(bet) {
		let reactKey = "key bet-draw-sel-" +
			props.couponKey +
			"-container-" +
			props.container +
			"-pal-" +
			selection.pal +
			"-avv-" +
			selection.avv +
			"-scom-" +
			bet.scomSogei +
			"_" +
			bet.handicap +
			"-draw-" +
			bet.draw;
		return reactKey;
	}
	function toggleBanker() {
		if (bankerEnabled) {
			selection.banker = !selection.banker;
			betslipContext.setBetslipData(betslipData, true);
		}
	}

	function deleteSelection(scomSogei, handicap, codDraw) {
		betslipContext.toggleSelectionBetslip(selection.pal, selection.avv, null, null, null, scomSogei, handicap, null, codDraw, null, null);
	}
	let idElement = "bet-event-coupon-" + props.couponKey + "-container-" + props.container + "-pal-" + selection.pal + "-avv-" + selection.avv;
	idElement = idElement + (isSingle ? "-for-bet-" + (bets[0].scomSogei + "-" + bets[0].handicap + "-" + bets[0].draw) : "");

	function getPlayabilityIssueMessage(bet) {
		let playabilityIssue = null;
		if (isMultiple && (bet.minPlError || bet.maxPlError)) {
			let minPl = bet.minPl ? bet.minPl : 1;
			let maxPl = bet.maxPl ? bet.maxPl : (conf.meb ? conf.meb : 30);
			if (minPl > 1) {
				minPl--;
			}
			if (maxPl > 1) {
				maxPl--;
			}
			playabilityIssue = getLabel('playability.min_max_issue');
			playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
			playabilityIssue = playabilityIssue.replaceAll('{{MAX_SEL}}', maxPl);
		}
		if (isMultiple && !playabilityIssue && bet.minOddError) {
			playabilityIssue = getLabel('playability.min_odd_issue');
			playabilityIssue = playabilityIssue.replaceAll('{{MIN_ODD}}', oddToString(bet.minOddError));
		}

		if (isSingle && bet.minPlError) {
			let minPl = bet.minPl ? bet.minPl : 1;
			if (minPl > 1) {
				minPl--;
			}
			playabilityIssue = getLabel('playability.min_issue');
			playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
		}
		return playabilityIssue;
	}

	return <div className='betslip__wrapper-border'>
		{
			bets.map(function (bet, i) {
				const showMatchDescription = i == 0;
				const key = getBetKey(bet);
				const playabilityIssue = getPlayabilityIssueMessage(bet);
				return <React.Fragment key={key}>
					<div className='grid__coupon_wh'>
						<div className={'events__selection ' + key + (selection.closed ? ' selectionClosed' : '')}>
							{showMatchDescription && <>
								{selection.closed && <div className="eventClosed">{getLabel('carrello.event.event_closed')}</div>}
								<div>
									<span className={`${isLive && 'events__team-live'} events__team`} >{selection.descEvent}</span>
								</div>
							</>
							}
							<div>
								<span className={`${isLive && 'events__outcome-live'} events__outcome`}>
									{bet.descBet}:
									<span className='events__outcome-bold'>{bet.descDraw}</span>
								</span>
							</div>
						</div>
						<div className='odd__amount'>
							{isSystem && i == 0 && bankerEnabled &&
								<label className={`custom-switch-2 ${bet.closed || selection.closed && "switch-gameClosed"}`}>
									<input checked={selection.banker} onChange={(e) => toggleBanker()} type="checkbox" />
									<div className="custom-switch-2-text">{getLabel('systembet.fixed_char')}</div>
									<span className="custom-slider-2 round"></span>
								</label>
							}
							<div className='odd_amount-wrapper'>
								<div className={bet.updated != null ? (bet.updated === 'increased' ? ' verde' : ' rosso') : ''}>
									<span className={bet.closed || selection.closed && "label-gameClosed"}>{bet.closed || selection.closed ? getLabel('general.giocabilita_chiusa') : oddToString(bet.odd)}</span>
									{bet.updated && <span className={"arrow-" + (bet.updated === 'increased' ? 'up' : 'down')} />}
								</div>

								{isSingle && <div className={bet.closed || selection.closed && "input-gameClosed"}><AmountBetslipForm container={props.container}
									linkedElement={idElement}
									couponKey={props.couponKey}
									isEventForm={true}
									hideCalcAndLabel={true}
									pal={selection.pal}
									avv={selection.avv}
									scomSogei={bet.scomSogei}
									handicap={bet.handicap}
									draw={bet.draw} /></div>
								}

								<button className='grid-schedina_bottone-generico' onClick={() => { deleteSelection(bet.scomSogei, bet.handicap, bet.draw) }}>
									<i className='odd__icon-thrash'></i>
								</button>
							</div>
						</div>
					</div>
					{
						playabilityIssue &&
						<div className='playabilityIssue__wrapper'>
							<div className="playabilityIssue">
								{playabilityIssue}
							</div>
						</div>
					}
				</React.Fragment>
			})
		}
	</div>
}

export default EventCouponWh